import React, { useState } from "react";
import { DatePicker, Space } from "antd";
import { connect } from "react-redux";
import {
  getStats,
  getUserDashBoardData,
  setEndDate,
  setStartDate,
} from "actions/userManagement";
import PageDataLoader from "components/pageDataLoader";
import {
  fetchTransaction,
  setAllActivitiesFilter,
} from "actions/feeManagement";
import moment from "moment";
const { RangePicker } = DatePicker;

const CalenderPopup = ({
  setStartDate,
  getDashBoardData,
  setEndDate,
  barGraphPlotFunction,
  togglePageLoader,
  getStats,
  dashBoardRole,
  getUserDashBoardData,
  showCustomCal,
  fetchTransaction,
  setAllActivitiesFilter,
  tooglePageLoader,
  allActivitiesFilter,
  isMonthOrWeek,
}) => {
  const [pageLoader, setPageLoader] = useState(false);
  const [hackValue, setHackValue] = useState(null);

  function onChange(dates, dateStrings) {
    setHackValue(null);
    if (dates && dates[0] && dates[1] && isMonthOrWeek === 'week') {
      if (dates[1].diff(dates[0], 'days') + 1 > 7) return;
    }
    if (dateStrings && dateStrings[0] && dateStrings[1]) {
      setAllActivitiesFilter("startDate", moment(dateStrings[0],'DD-MM-YYYY').format('YYYY-MM-DD'));
      setAllActivitiesFilter("endDate", moment(dateStrings[1],'DD-MM-YYYY').format('YYYY-MM-DD'));
      tooglePageLoader(true);
      fetchTransaction(() => tooglePageLoader(false));
      showCustomCal(false);
    } else {
      setAllActivitiesFilter("startDate", undefined);
      setAllActivitiesFilter("endDate", undefined);
    }
  }

  const disabledDate = (current) => {
    if (isMonthOrWeek === 'week' && hackValue && hackValue[0]) {
      return current.diff(hackValue[0], 'days') > 6 || hackValue[0].diff(current, 'days') > 6;
    }
    return false;
  };

  const onCalendarChange = (val) => setHackValue(val);
  const onOpenChange = (open) => { if (open) setHackValue([null, null]); else setHackValue(null); };

  return (
    <div className="rangePicker">
      <Space
        direction="vertical"
        mode={"month"}
        size={12}
        style={{ width: "240px", marginLeft: "-5px" }}
      >
        <RangePicker
          dropdownClassName={"rangePickerB"}
          placeholder={["Start Date", "End Date"]}
          onChange={onChange}
          onCalendarChange={onCalendarChange}
          onOpenChange={onOpenChange}
          disabledDate={disabledDate}
          renderExtraFooter={() => "extra footer"}
          showTime
          value={hackValue !== null ? hackValue : [allActivitiesFilter?.startDate && moment(allActivitiesFilter.startDate), allActivitiesFilter?.endDate && moment(allActivitiesFilter.endDate)]}
          format={"DD-MM-YYYY"}
        />
      </Space>
      <PageDataLoader visible={pageLoader} />
    </div>
  );
};
const mapStateToProps = (state) => {
  const { tab, dashBoardRole, isMonthOrWeek } = state.userManagement;
  return {
    tab,
    dashBoardRole,
    isMonthOrWeek,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setStartDate: (m) => dispatch(setStartDate(m)),
  setEndDate: (m) => dispatch(setEndDate(m)),
  getStats: (callback) => dispatch(getStats(callback)),
  getUserDashBoardData: (callback) => dispatch(getUserDashBoardData(callback)),
  //   getDashBoardData: (callback) => dispatch(getDashBoardData(callback))
  fetchTransaction: (callback) => dispatch(fetchTransaction(callback)),
  setAllActivitiesFilter: (key, val) =>
    dispatch(setAllActivitiesFilter(key, val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalenderPopup);
